import { getShellApiInstance } from '../../common/shell-api-helpers/shell-api-instance'

const getUserPreferences = () => getShellApiInstance().userPreferences

export const getSearchHistory = async () =>
  (await getUserPreferences()?.getPreference<string[], string[]>('search-history', [])) ?? []

export const addToSearchHistory = async (searchQuery: string) => {
  const userPreferences = getUserPreferences()

  const searchHistory = await getSearchHistory()
  searchHistory?.unshift(searchQuery)
  const newSearchHistory = [...new Set(searchHistory)]
  userPreferences?.setPreference('search-history', newSearchHistory)
}

export const removeFromSearchHistory = async (searchQuery: string) => {
  const userPreferences = getUserPreferences()

  const searchHistory = await getSearchHistory()
  searchHistory.splice(searchHistory.indexOf(searchQuery), 1)
  userPreferences?.setPreference('search-history', searchHistory)
}
